import { ProseMirror } from '@progress/kendo-react-editor'

export const copyStylesheetLinkPlugin = () =>
  new ProseMirror.Plugin({
    view: (view) => {
      const root = view.dom.getRootNode() as Document
      const head = root.head

      const links = document.getElementsByTagName('link')
      const clonedLinks: HTMLLinkElement[] = []
      for (const link of links) {
        if (link.rel === 'stylesheet') {
          const clonedLink = link.cloneNode() as HTMLLinkElement
          clonedLinks.push(clonedLink)
          head.appendChild(clonedLink)
        }
      }

      return {
        destroy: () => {
          for (const clonedLink of clonedLinks) {
            head.removeChild(clonedLink)
          }
        },
      }
    },
  })
